<!-- NEWDESIGN DONE -->
@if ((appIsInitializing$ | async) === false) {
<div
  class="transition-opacity"
  [ngClass]="{ 'opacity-0 height-0 overflow-hidden': appIsLoading }"
  id="rootContainer"
>
  <router-outlet></router-outlet>
</div>

<app-accept-cookies />

} @else {
<div class="center-in-container">
  <app-loader-hashtag />
</div>
}

<app-internet-status />

@if (impersonateUser$ | async; as impersonateUser) {
<app-root-badge
  i18n-buttonLabel="@@utils.annuler"
  buttonLabel="Annuler"
  (stop)="stopImpersonateUser()"
>
  <p i18n="@@impersonateUser.connecte">Connecté en tant que {{ impersonateUser.username }}</p>
</app-root-badge>
} @if (examTestingState$ | async; as examTestingState) {
<app-root-badge i18n-buttonLabel="@@utils.arreter" buttonLabel="Arrêter" (stop)="stopTestingExam()">
  <p i18n="@@examTestingState.mode">Mode TEST</p>
  <p i18n="@@examTestingState.stop" class="text-xs font-normal">
    L'arrêt du mode test entrainera la suppression de la session de test. Ne l'arrêtez pas avant
    d'avoir terminé.
  </p>
</app-root-badge>
}
